import styled from 'styled-components';

export const TemplatesContainer = styled.div`
    display: flex;
    flex-wrap: wrap;
    justify-content: space-between;
    gap: 10px;
    align-items: flex-start;
`;

export const TemplateItem = styled.div`
    display: flex;
    flex-direction: column;
    cursor: pointer;
    position: relative;
    gap: 6px;
    overflow: hidden;

    &::before {
        content: '';
        position: absolute;
        top: 0;
        left: 0;
        width: 100%;
        height: 100%;
        background: rgba(0, 0, 0, 0.2);
        opacity: 0;
        transition: opacity 0.3s ease;
        z-index: 1;
        pointer-events: none;
    }

    &:hover::before {
        opacity: 1;
    }
`;

export const StyledDeleteButton = styled.button`
    display: inline-flex;
    justify-content: center;
    align-items: center;
    height: 24px;
    width: 24px;
    padding: 0;
    border-radius: 6px;
    background: #fff;
    border: 1px solid #e7e7e7;
    flex-shrink: 0;
    z-index: 3;
    cursor: pointer;
    position: absolute;
    top: 6px;
    right: 6px;
    opacity: 0;
    pointer-events: none;
    transform: translateY(-4px);
    transition:
        border-color 0.2s ease,
        background-color 0.2s ease,
        opacity 0.2s ease,
        transform 0.2s ease;

    ${TemplateItem}:hover &,
    ${TemplateItem}:focus-within & {
        opacity: 1;
        pointer-events: auto;
        transform: translateY(0);
    }

    img {
        height: 14px;
    }

    &:hover {
        border-color: #d91919;
        background: #fff5f5;
    }

    &:focus {
        outline: 2px solid #d91919;
        outline-offset: 1px;
    }
`;

export const TemplateFooter = styled.div`
    width: 115px;
    display: flex;
    align-items: center;
    gap: 6px;
`;

export const TemplateTitle = styled.div`
    color: #a1a1a1;
    font-size: 10px;
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
    flex: 1;
    min-width: 0;
    line-height: 1.2;
    padding-bottom: 2px;
`;

export const TemplatePreview = styled.div`
    position: relative;
    width: 115px;
    height: 125px;
    display: flex;
    align-items: center;
    justify-content: center;
    border-radius: 6px;
    overflow: hidden;

    img {
        border-radius: 6px;
    }
`;

export const StyledContainer = styled.div`
    display: flex;
    flex: 1;
    flex-direction: column;
    padding: 20px 18px;
    overflow: auto;
`;
